export enum FieldSources {
    AzureActiveDirectory = "AzureActiveDirectory",
    Workday = "Workday",
    AzureActiveDirectoryOtherwiseWorkday = "AzureActiveDirectoryOtherwiseWorkday",
    WorkdayOtherwiseAzureActiveDirectory = "WorkdayOtherwiseAzureActiveDirectory",
}
